import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { packStock } from '@/services/tissueJwApi';

export const PackStockTable = () => {
  const [data, setData] = useState({ items: [], total_packs: 0 });
  useEffect(() => { packStock().then(setData).catch(() => {}); }, []);
  return (
    <Card>
      <CardContent className="pt-6 space-y-3">
        <p className="text-sm text-gray-600" data-testid="pack-stock-total">
          {data.total_packs} pack(s) in Tissue stock — box them in Tissue Assortment, then send the boxes via Internal Transfer.
        </p>
        <Table>
          <TableHeader>
            <TableRow><TableHead>FG</TableHead><TableHead>Design</TableHead><TableHead>Shade / Size</TableHead>
              <TableHead className="text-right">Packs</TableHead><TableHead className="text-right">Pieces</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {!data.items.length && (
              <TableRow><TableCell colSpan={5} className="text-center text-gray-400 py-6">No packs in stock</TableCell></TableRow>
            )}
            {data.items.map((r) => (
              <TableRow key={r.fg_name} data-testid={`pack-stock-row-${r.fg_name}`}>
                <TableCell className="font-mono text-xs">{r.fg_name}</TableCell>
                <TableCell>{r.design_name}</TableCell>
                <TableCell className="text-xs text-gray-600">{[r.shade, r.size].filter(Boolean).join(' · ')}</TableCell>
                <TableCell className="text-right font-semibold">{r.packs}</TableCell>
                <TableCell className="text-right">{r.pcs}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default PackStockTable;
